import { AlertTriangle } from "lucide-react";

// UNSUPPORTED MARKET card. Must NEVER be used for supported-but-
// unmatched legs. Preserves exact copy: "PA does not analyze this
// market yet." (falls back to the backend-provided message).
export function UnsupportedLegCard({ leg }) {
  return (
    <section
      data-testid={`analyzer-leg-unsupported-${leg.index}`}
      className="pa-card p-6 md:p-8 mt-3"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle size={22} style={{ color: "#b45309" }} />
        <div>
          <h5 className="font-display text-base md:text-lg uppercase tracking-wide text-slate-900">
            Unsupported Market
          </h5>
          <p className="mt-1 text-slate-600 text-sm">
            {leg.message || "PA does not analyze this market yet."}
          </p>
        </div>
      </div>
    </section>
  );
}
